export default __webpack_public_path__ + "static/collective-ai-dark-5c84770386b446acbc60a3ac60b89a681a8254ca5717dbcd594cadfac12d9d86.png";